import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { TournamentContext } from 'components/Tournament/__Tournament.context'

const Tournament: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.TournamentParams>()

  return (
    <TournamentContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </TournamentContext.Provider>
  )
}

export default Tournament
